<template>
  <div class="flex-center position-ref full-height">
    <div class="content">
      <Loading :loading="loading"></Loading>
      <img src="/assets/logos/myeduassessment.png" alt="" />
      <h3 v-if="this.$route.query.sso && !error">Lütfen bekleyiniz, ilgili platforma yönlendiriliyorsunuz.</h3>
      <SsoError v-if="error" :message="error"></SsoError>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import SsoError from "@/components/SsoError";
import axios from "axios";
import CryptoJS from "crypto-js";

export default {
  name: "MyEduAssessment",
  components: {
    Loading,
    SsoError
  },
  data() {
    return {
      loading: false,
      secretKey: 'zHjnVhHnT.D_8@bp29QZKeLr6VfePjrm.8msWgzR9hU.CbJUcEVhQuJ6NTJtQJCE',
      userData: null,
      error: null,
    }
  },
  beforeMount() {
    const query = this.$route.query;
    if (query.sso) {
      this.loading = true
      // gelen data çözülüyor
      const decode = decodeURIComponent(atob(query.sso));
      const bytes = CryptoJS.AES.decrypt(decode, this.secretKey).toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(bytes);
      this.ueslmsCheckUser();
    }
  },
  methods: {
    fail(message) {
      this.loading = false;
      this.error = message;
      console.log('MyEduAssessment SSO:', message);
    },

    ueslmsCheckUser() {
      axios.post('https://www.ueslms.com/api/v2/myeduassessment/user/check', {user: this.userData})
      // axios.post('https://ueslms.test/api/v2/myeduassessment/user/check', {user: this.userData})
          .then(response => {
            if (response.data.success) {
              this.goMyEduAssessment()
            } else if (response.data.message) {
              this.fail(response.data.message)
            } else {
              this.ueslmsCreate()
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    ueslmsCreate() {
      axios.post('https://www.ueslms.com/api/v2/myeduassessment/user/create', this.userData)
      // axios.post('https://ueslms.test/api/v2/myeduassessment/user/create', this.userData)
          .then(response => {
            if (response.data.success) {
              this.goMyEduAssessment()
            } else {
              this.fail(response.data.message || 'Kullanıcı oluşturulamadı. Lütfen tekrar deneyin.')
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    async goMyEduAssessment() {
      const role = this.userData.role_type;
      if (role === 'student') {
        location.href = "https://www.myeduassessment.com/#/login?username=" + btoa(this.userData.username) + "&password=" + btoa('123456');
      } else if (role === 'teacher') {
        location.href = "https://report.myeduassessment.com/#/?username=" + btoa(this.userData.username) + "&password=" + btoa('Ues1234!');
      } else {
        location.href = "https://www.myeduassessment.com";
      }
    },

  }
}
</script>
